// @core/api/endpoints/subscription/list_plans.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPlansResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List subscription plans
 * Returns available subscription plans with optional filtering by type and visibility. Public endpoint for plan browsing and comparison.
 * @public This endpoint does not require authentication
 */
export async function ListPlans(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPlansResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/plans`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListPlansResponse>(requestPath, { ...requestOptions, params });
}
